import {
  handleErrorWithSentry,
  // replayIntegration
} from '@sentry/sveltekit'
import * as Sentry from '@sentry/sveltekit'

// ? Consider switching to Sentry telemetry (perf/issues monitoring) from Vercel Speed Insights. Currently disabled
Sentry.init({
  dsn: 'https://50e06a336c143b50d19858742619ca54@o4507947332272128.ingest.us.sentry.io/4508615616757760',
})

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry()
